import { FavoritesRequest, MemberDetailedInfo, User } from "@/types";

import { axios } from "../axios.instance";

export type GetViewedMeUsersRequest = FavoritesRequest & {
  perPage?: number;
  cursor?: string;
};

export type GetViewedMeUsersResponse = {
  data: Array<Pick<User, "id" | "role"> & MemberDetailedInfo>;
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const getViewedMeUsers = async (params: GetViewedMeUsersRequest): Promise<GetViewedMeUsersResponse> => {
  const { data } = await axios.get(`/views/users/viewed-my-profile`, {
    params,
  });

  return data;
};
